import { css, cx } from '@emotion/css';
import { Row, Col, Skeleton, Space } from 'antd';
import { useIsMobile } from 'src/hooks';
import { MCard, MTypography } from 'src/lib';
import { AccountBalanceSummaryView } from 'src/models';
import { ColorConstant, Display, FlexDirection, ScreenBreakpoint, Spacing } from 'src/styles';

import { BalanceSummary } from './BalanceSummary';
import { BalanceSummaryChart } from './BalanceSummaryChart';

const titleRowStyle = css`
  ${Spacing.mt32}
  ${Spacing.mb12}
`;

const cardStyle = css`
  ${Spacing.p24}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.p4};
  }
`;

interface AccountSummaryProps {
  title: string;
  isLoading: boolean;
  accountValue: number;
  balanceSummary: AccountBalanceSummaryView;
  onRefresh: () => void;
}

export const AccountSummary = ({ title, isLoading, accountValue, balanceSummary, onRefresh }: AccountSummaryProps) => {
  const isMobile = useIsMobile();

  return (
    <Skeleton loading={isLoading}>
      <Row className={titleRowStyle}>
        <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
          {title}
        </MTypography>
      </Row>
      <Row justify='center'>
        <Col span={24}>
          <MCard className={cardStyle}>
            <Row>
              <Col
                span={24}
                className={cx(Display.flex, isMobile ? FlexDirection.column : FlexDirection.row, Spacing.p24)}>
                <Space.Compact direction={isMobile ? 'vertical' : 'horizontal'} block>
                  <BalanceSummaryChart accountValue={accountValue} summary={balanceSummary} />
                  <BalanceSummary summary={balanceSummary} onRefresh={onRefresh} />
                </Space.Compact>
              </Col>
            </Row>
          </MCard>
        </Col>
      </Row>
    </Skeleton>
  );
};
